import Styles from './ConnectAccount.module.scss'
import { ProviderIcon } from 'blaze-ui/icons/ProviderIcon'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { Button } from 'blaze-ui/Button'
import { UserProfileAdd2 } from 'blaze-ui/icons'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'

const ProviderLabels: Record<ExternalIntegrationEnum, string> = {
  [ExternalIntegrationEnum.Facebook]: 'Facebook',
  [ExternalIntegrationEnum.Instagram]: 'Instagram',
  [ExternalIntegrationEnum.LinkedIn]: 'LinkedIn',
  [ExternalIntegrationEnum.X]: 'X / Twitter',
  [ExternalIntegrationEnum.Google]: 'Google',
  [ExternalIntegrationEnum.WordPress]: 'WordPress',
  [ExternalIntegrationEnum.GoHighLevel]: 'GoHighLevel',
  [ExternalIntegrationEnum.Wix]: 'Wix',
  [ExternalIntegrationEnum.YouTube]: 'YouTube',
  [ExternalIntegrationEnum.Mailchimp]: 'Mailchimp',
  [ExternalIntegrationEnum.Shopify]: 'Shopify',
  [ExternalIntegrationEnum.TikTok]: 'TikTok',
  [ExternalIntegrationEnum.GoogleDrive]: 'Google Drive',
  [ExternalIntegrationEnum.MetaAds]: 'Meta Ads',
  [ExternalIntegrationEnum.GoogleAds]: 'Google Ads',
  [ExternalIntegrationEnum.GoogleBusinessProfile]: 'Google Business Profile',
  [ExternalIntegrationEnum.GoogleCalendar]: 'Google Calendar',
  [ExternalIntegrationEnum.MicrosoftGraph]: 'Outlook Calendar',
  [ExternalIntegrationEnum.Zapier]: 'Zapier',
}

export const ConnectAccount = ({ provider }: { provider: ExternalIntegrationEnum }) => {
  const { connect } = useConnectAccountPopup()

  return (
    <div className={Styles.wrapper}>
      <ProviderIcon size={20} provider={provider} />
      <InitiateOauthTrigger provider={provider} popUp onInitiatedOauth={connect}>
        <Button color="var(---dark-80)" variant="ghost" size="sm" frontIcon={UserProfileAdd2}>
          Connect {ProviderLabels[provider]}
        </Button>
      </InitiateOauthTrigger>
    </div>
  )
}
